import { BrokerJob, TenantJobSearchStatus } from '@warehouse/object-browser/feature-broker-core';

/** Grid column fields. Rows keep the Broker's order (newest first), exactly like the Logs tab: no sorting. */
export const ServiceColumnName = 'serviceName';
export const ObjectColumnName = 'object';
export const BucketColumnName = 'bucket';
export const StatusColumnName = 'status';
export const TriggeredByColumnName = 'triggeredByDisplayName';
export const StartColumnName = 'startedAt';
export const EndColumnName = 'closedAt';
export const DurationColumnName = 'duration';
export const JobIdColumnName = 'jobId';
export const ActionsColumnName = '__actions';

export const SERVICE_LOG_COLUMN_FIELDS = [
	ServiceColumnName,
	ObjectColumnName,
	BucketColumnName,
	StatusColumnName,
	TriggeredByColumnName,
	StartColumnName,
	EndColumnName,
	DurationColumnName,
	JobIdColumnName,
] as const;

export type ServiceLogColumnField = (typeof SERVICE_LOG_COLUMN_FIELDS)[number];

export function isServiceLogColumnField(field: string): field is ServiceLogColumnField {
	return (SERVICE_LOG_COLUMN_FIELDS as readonly string[]).includes(field);
}

/** The status chips above the grid: one search status, or everything. */
export type ServiceLogStatusQuickFilter = TenantJobSearchStatus | 'ALL';

export const SERVICE_LOG_STATUS_QUICK_FILTERS: { value: ServiceLogStatusQuickFilter; label: string }[] = [
	{ value: 'ALL', label: 'All' },
	{ value: 'RUNNING', label: 'Running' },
	{ value: 'SUCCEEDED', label: 'Succeeded' },
	{ value: 'FAILED', label: 'Failed' },
	{ value: 'CANCELLED', label: 'Cancelled' },
];

/** Duration in milliseconds, or null while the job is still open. */
export function jobDurationMs(job: BrokerJob): number | null {
	if (job.closedAt === null) return null;
	return Math.max(0, job.closedAt - job.startedAt);
}

export function formatDuration(durationMs: number | null): string {
	if (durationMs === null) return '--';
	const totalSeconds = Math.round(durationMs / 1000);
	const hours = Math.floor(totalSeconds / 3600);
	const minutes = Math.floor((totalSeconds % 3600) / 60);
	const seconds = totalSeconds % 60;
	if (hours > 0) return `${hours}h ${minutes}m`;
	if (minutes > 0) return `${minutes}m ${seconds}s`;
	return `${seconds}s`;
}
